import { Form, Row, Col } from "react-bootstrap";
import { FiCalendar, FiStar } from "react-icons/fi";
import { useState } from "react";
// import AddDealModal from "../../AddDealModal";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import AddDealModal from "../AddDealModal";
const BasicInfoTab = () => {
  const [preview, setPreview] = useState(null);
  const [dob, setDob] = useState(null);
  const [showDealModal, setShowDealModal] = useState(false);
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };
  const [tagInput, setTagInput] = useState("");
  const [tagList, setTagList] = useState([
    "Collab",
    "Promotion",
    "Rated",
    "Davis",
  ]);

  // Add tag
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && tagInput.trim() !== "") {
      e.preventDefault();

      if (!tagList.includes(tagInput.trim())) {
        setTagList([...tagList, tagInput.trim()]);
      }

      setTagInput("");
    }
  };

  // Remove tag
  const removeTag = (index) => {
    setTagList(tagList.filter((_, i) => i !== index));
  };
  return (
    <>
      {/* UPLOAD */}
      <div className="upload-box mb-4">
        <div className="upload-left">
          {preview ? (
            <img src={preview} alt="preview" />
          ) : (
            <div className="upload-circle"></div>
          )}
        </div>

        <div>
          <h6>Upload Profile Image</h6>
          <small>Image should be below 4 mb</small>

          <div className="mt-2">
            <input
              type="file"
              id="upload"
              hidden
              onChange={handleImageUpload}
            />

            <label htmlFor="upload" className="btn-orange btn-sm me-2">
              Upload
            </label>

            <button className="btn btn-light btn-sm">Cancel</button>
          </div>
        </div>
      </div>

      {/* ROW 1 */}
      <Row>
        <Col md={4}>
          <Form.Label>First Name *</Form.Label>
          <Form.Control />
        </Col>
        <Col md={4}>
          <Form.Label>Last Name</Form.Label>
          <Form.Control />
        </Col>
        <Col md={4}>
          <Form.Label>Job Title *</Form.Label>
          <Form.Control />
        </Col>
      </Row>

      {/* ROW 2 */}
      <Row className="mt-3">
        <Col md={4}>
          <Form.Label>Company Name *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
        <Col md={4}>
          <Form.Label>Email</Form.Label>
          <Form.Control />
        </Col>
        <Col md={4}>
          <Form.Label>Phone Number *</Form.Label>
          <Form.Control />
        </Col>
      </Row>

      {/* ROW 3 */}
      <Row className="mt-3">
        <Col md={4}>
          <Form.Label>Phone Number 2 *</Form.Label>
          <Form.Control />
        </Col>
        <Col md={4}>
          <Form.Label>Fax</Form.Label>
          <Form.Control />
        </Col>
        <Col md={4}>
          <div className="d-flex justify-content-between">
            <Form.Label>Deals *</Form.Label>
            <span className="add-new" onClick={() => setShowDealModal(true)}>
              + Add New
            </span>
          </div>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
      </Row>

      {/* ROW 4 */}
      <Row className="mt-3">
        <Col md={4}>
          <Form.Label>
            Date of Birth <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <div
            style={{ position: "relative" }}
            onClick={(e) => e.currentTarget.querySelector("input").focus()}
          >
            <DatePicker
              selected={dob}
              onChange={(date) => setDob(date)}
              dateFormat="dd-MM-yyyy"
              placeholderText="dd/mm/yyyy"
              popperPlacement="bottom-start"
              className="form-control"
              calendarClassName="custom-calendar-inline"
              style={{
                width: "100%",
                height: "45px",
                borderRadius: "8px",
                paddingRight: "40px",
              }}
            />

            {/* Calendar Icon */}
            <FiCalendar
              style={{
                position: "absolute",
                right: "50px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#6b7280",
                pointerEvents: "none",
              }}
            />
          </div>

          {/* INLINE STYLE OVERRIDE */}
          <style>
            {`
        .custom-calendar-inline {
          border-radius: 12px;
          border: none;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          padding: 10px;
        }

        .react-datepicker__header {
          background: #fff;
          border-bottom: none;
        }

        .react-datepicker__current-month {
          font-weight: 600;
          font-size: 16px;
        }

        .react-datepicker__day {
          border-radius: 8px;
        }

        .react-datepicker__day--selected,
        .react-datepicker__day--keyboard-selected {
          background-color: #f97316 !important;
          color: #fff !important;
        }

        .react-datepicker__day:hover {
          background-color: #fde3cf;
        }

        .react-datepicker__day--today {
          background-color: #e5e7eb;
        }

        /* Make responsive */
        @media (max-width: 768px) {
          .react-datepicker {
            width: 100% !important;
          }
        }
        `}
          </style>
        </Col>

        <Col md={4}>
          <Form.Label>Ratings *</Form.Label>
          <div className="rating-box">
            <Form.Control />
            <FiStar />
          </div>
        </Col>

        <Col md={4}>
          <Form.Label>Owner *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
      </Row>

      {/* ROW 5 */}
      <Row className="mt-3">
        <Col md={4}>
          <Form.Label>Industry *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
        <Col md={4}>
          <Form.Label>Currency *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
        <Col md={4}>
          <Form.Label>Language *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
      </Row>

      {/* ROW 6 */}
      <Row className="mt-3">
        <Col md={6}>
          <Form.Label>
            Tags <span style={{ color: "red" }}>*</span>
          </Form.Label>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "6px",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              padding: "8px",
              minHeight: "45px",
            }}
          >
            {tagList.map((tag, index) => (
              <span
                key={index}
                style={{
                  background: "#e5e7eb",
                  padding: "4px 8px",
                  borderRadius: "6px",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  fontSize: "13px",
                }}
              >
                {tag}
                <button
                  onClick={() => removeTag(index)}
                  style={{
                    border: "none",
                    background: "none",
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              </span>
            ))}

            <input
              type="text"
              placeholder="Add new"
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={handleKeyDown}
              style={{
                border: "none",
                outline: "none",
                flex: 1,
                minWidth: "120px",
              }}
            />
          </div>
        </Col>

        <Col md={6}>
          <Form.Label>Source *</Form.Label>
          <Form.Select className="custom-select">
            <option>Select</option>
          </Form.Select>
        </Col>
      </Row>
      <AddDealModal
        show={showDealModal}
        handleClose={() => setShowDealModal(false)}
      />
      {/* STYLES */}
      <style>{`
        /* UPLOAD */
        .upload-box {
          display: flex;
          gap: 15px;
          background: #f9fafb;
          padding: 15px;
          border-radius: 8px;
          align-items: center;
        }

        .upload-left img,
        .upload-circle {
          width: 70px;
          height: 70px;
          border-radius: 50%;
        }

        .upload-circle {
          background: #eee;
          border: 2px dashed #ddd;
        }

        /* BUTTON */
        .btn-orange {
          background: #ff6b2c;
          border: none;
          color: white;
        }

        .btn-orange:hover {
          background: #e65a1f;
        }

        /* SELECT ORANGE */
        .custom-select:focus {
          border-color: #ff6b2c;
          box-shadow: 0 0 0 0.2rem rgba(255,107,44,0.2);
        }

        option:checked {
          background: #ff6b2c;
          color: white;
        }

        /* DATE */
        .date-box {
          position: relative;
        }

        .date-box svg {
          position: absolute;
          right: 10px;
          top: 10px;
        }

        /* RATING */
        .rating-box {
          position: relative;
        }

        .rating-box svg {
          position: absolute;
          right: 10px;
          top: 10px;
        }

        /* TAGS */
        .tags-box {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          border: 1px solid #ddd;
          padding: 6px;
          border-radius: 6px;
        }

        .tags-box span {
          background: #e5e7eb;
          padding: 4px 8px;
          border-radius: 6px;
          font-size: 12px;
        }

        .tags-box input {
          border: none;
          outline: none;
          flex: 1;
        }

        .add-new {
          color: #ff6b2c;
          font-size: 13px;
          cursor: pointer;
        }

        /* MOBILE */
        @media(max-width:768px){
          .upload-box {
            flex-direction: column;
            align-items: flex-start;
          }
        }
      `}</style>
    </>
  );
};

export default BasicInfoTab;
